var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditIconWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6237 5.70991C12.7025 5.63239 12.8088 5.58923 12.9194 5.58985C13.03 5.59048 13.1358 5.63484 13.2137 5.71324L15.1204 7.61991C15.1594 7.65839 15.1904 7.7042 15.2117 7.7547C15.233 7.80521 15.2441 7.85941 15.2445 7.91422C15.2448 7.96902 15.2343 8.02335 15.2135 8.07409C15.1928 8.12483 15.1623 8.17099 15.1237 8.20991L9.16704 14.1666L6.66704 11.6666L12.6237 5.70991ZM5.83371 12.4999L8.33371 14.9999L5.40871 15.7307C5.18371 15.7874 5.04537 15.6541 5.10287 15.4249L5.83371 12.4999Z",
    fill: "#F7FBFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIconWhite);
export default __webpack_public_path__ + "static/media/EditIconWhite.64f1b9e70714f70c2db1c0ba2cd59b4b.svg";
export { ForwardRef as ReactComponent };